import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BookingFor as BookingForType } from '@customTypes/BookingFor'
import RadioButton from '@components/RadioButton'
import RadioGroup from '@components/RadioGroup'
import useStyles from './BookingFor.styles'
import { useIsChildProphylaxis } from '@hooks/useIsChildProphylaxis'

const BookingFor: React.FC = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { register } = useFormContext()
  const { isChildProphylaxis } = useIsChildProphylaxis()

  return (
    <div className={classes.root}>
      <RadioGroup flex={isChildProphylaxis}>
        {!isChildProphylaxis && (
          <RadioButton id={BookingForType.BOOKING_FOR_ME} label={t('booking_for_me')} {...register('bookingFor')} />
        )}
        <RadioButton
          id={BookingForType.BOOKING_FOR_OTHER}
          label={t('booking_for_other')}
          className={classes.bookingForOtherOption}
          {...register('bookingFor')}
        />
      </RadioGroup>
    </div>
  )
}

export default BookingFor
